exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading[data-v-00f26ff0] {\n  margin: 1rem;\n  margin-bottom: 0rem;\n  text-align: center;\n}\n.loading img[data-v-00f26ff0] {\n    width: 2.8rem;\n}\n", ""]);

// exports
